import { connect } from 'react-redux';
import { ProgressBar } from 'components/common';

const TasksProgress = connect((state) => ({
  messages: state.messages,
  theme: state.theme
}))(({ messages, numberOfAnswers, numberOfTasks, tasksProgress, theme }) => {
  if (!numberOfTasks) {
    return (
      <div
        style={{
          color: theme.textColorLighter,
          fontSize: '1.3rem',
          whiteSpace: 'nowrap'
        }}
      >
        {messages.tasksNoTasks}
      </div>
    );
  }

  return (
    <div className="progress">
      <ProgressBar
        ariaLabel={messages.tasksTaskPoints}
        color={theme.successStandaloneColor}
        label={
          <div>
            {`${Math.round(tasksProgress * 100)}%`}
            <span style={{ color: theme.textColorLighter, marginLeft: 8 }}>
              {`(${numberOfAnswers}/${numberOfTasks} ${messages.tasksNumberOfAnswers})`}
            </span>
          </div>
        }
        progress={tasksProgress}
        style={{ width: 160 }}
      />
    </div>
  );
});

export default TasksProgress;
